import axios from 'axios'
import { camelCase } from '../../modules/string_converter'

export const companiesTagGroups = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    readTagGroupsSuccess(state, payload) {
      const result = {}
      payload.data.map(tagGroup => {
        const obj = {}
        for (const [key, value] of Object.entries(tagGroup.attributes)) {
          obj[camelCase(key)] = value
        }
        result[camelCase(tagGroup.attributes.kind)] = obj
      })
      state.data = result
      state.loading = false
    },
    getErrorResponse(state) {
      state.loading = false
    },
  },
  actions: {
    readTagGroups({ commit, rootState }) {
      commit('apiConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/tag_groups.json')
        .then(res => {
          commit('readTagGroupsSuccess', res.data)
        })
        .catch(err => {
          commit('getErrorResponse')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  }
}
